import { editExistSubDatetimeFinish$ } from '../selectors/subscription';
import * as ExistSubscriptionActions from '../actions/existSubscription';
import subToasterContentAndTypeCreator from './subToaster/subToasterContentAndType';
import reloadExistSubscription from './reloadExistSubscription';

import * as Api from '../utils/api';
import * as Const from '../constants';

import ReduxAction from '../../../interfaces/ReduxAction';

export default function editExistSubscription (idSub: number): ReduxAction {
  return (dispatch, getState): void => {
    dispatch(ExistSubscriptionActions.existSubIsLoading());

    Api.editSubscription(idSub, editExistSubDatetimeFinish$(getState()))
      .then(() => {
        dispatch(subToasterContentAndTypeCreator(
          Const.SUBSCRIPTION_MESSAGE.edit.success,
          Const.MESSAGE_TYPE.success
        ));

        return Promise.resolve();
      })
      .catch(reason => {
        dispatch(subToasterContentAndTypeCreator(
          `${Const.SUBSCRIPTION_MESSAGE.edit.fail}. ${reason}`,
          Const.MESSAGE_TYPE.fail
        ));

        return Promise.reject();
      })

      .then(() => {
        dispatch(reloadExistSubscription());
      })
      .catch(() => {
        dispatch(ExistSubscriptionActions.existSubNotLoading());
      });
  };
}
